var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className,attrs:{"to":_vm.link,"title":_vm.title,"tag":"div"},on:{"click":function($event){return _vm.onClick(_vm.id)}}},[_c('span',{staticClass:"nav-sidebar-promo__item-image",style:({backgroundImage: ("url(" + _vm.resizedImage + ")")})})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57e66366","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/modules/shared/sidebar/SidebarPromoItem.vue
// module id = 1910
// module chunks = 0